export default __webpack_public_path__ + "static/media/way to selfie boothlabel.737dd3fa.png";